import { render, staticRenderFns } from "./DigitalReceituario.vue?vue&type=template&id=214cd164&scoped=true"
import script from "./DigitalReceituario.vue?vue&type=script&lang=js"
export * from "./DigitalReceituario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "214cd164",
  null
  
)

export default component.exports